export * from "./PageLegalRegulatory";
